import React from 'react';
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { CompanyAvatar } from "@/components/ui/company-avatar";

import { BusinessChatConversation } from '@/types/chat';
import { cn } from "@/lib/utils";
import { getCompanyAvatarProps } from "@/utils/chatAvatars";

interface ChatMinimizedProps {
  conversation: BusinessChatConversation;
  onRestore: () => void;
}

export function ChatMinimized({ conversation, onRestore }: ChatMinimizedProps) {

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div
      className={cn(
        "rounded-full h-12 px-3 shadow-md hover:shadow-lg transition-all duration-300 bg-card border border-border hover:bg-accent/20 hover:border-accent/50 hover:scale-105 backdrop-blur-md flex items-center gap-2 animate-scale-in text-card-foreground text-sm cursor-pointer w-44 sm:w-48 md:w-52"
      )}
      onClick={onRestore}
      role="button"
      aria-label={`Open chat with ${conversation.name}`}
    >
      <div className="flex-1 flex items-center gap-2 min-w-0">
{(() => {
          const companyAvatarProps = getCompanyAvatarProps(conversation as any);
          if (companyAvatarProps) {
            return (
              <CompanyAvatar 
                {...companyAvatarProps} 
                size="sm" 
                className="w-7 h-7 ring-2 ring-transparent group-hover:ring-primary/20 transition-all" 
              />
            );
          }
          return (
            <Avatar className="w-7 h-7 ring-2 ring-transparent group-hover:ring-primary/20 transition-all">
              <AvatarImage src={(conversation as any).profile_avatar_url || ''} alt={conversation.name} />
              <AvatarFallback className={cn(
                "text-[10px] font-medium",
                conversation.type === 'business'
                  ? "bg-chat-business-accent text-chat-business-foreground"
                  : "bg-chat-talent-accent text-chat-talent-foreground"
              )}>
                {getInitials(conversation.name)}
              </AvatarFallback>
            </Avatar>
          );
        })()}
        <span className="truncate text-sm flex-1 min-w-0">{conversation.name}</span>
        {conversation.unreadCount > 0 && (
          <Badge variant="unread" className="text-xs min-w-5 h-5 px-1.5 ml-1 flex-shrink-0">
            {conversation.unreadCount > 99 ? '99+' : conversation.unreadCount}
          </Badge>
        )}
      </div>
    </div>
  );
}